import React from "react";
import "./navbar.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import whatsapp from "../../assets/whatsapp.png";
import youtube from "../../assets/youtube.png";
import telegram from "../../assets/tegram.png";
import userlogo from "../../dist/images/profile/user-4.jpg";
import insta from "../../assets/instragram.png";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { origin_url } from "../../utils/Config";

function Navbar({ isMenuOpen, toggleMenu }) {
  const [isSticky, setIsSticky] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { walletAddress, userinfo, jwt } = useSelector((state) => state.wallet);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  // Handle the scroll event
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true); // Make the header sticky when scrolled more than 100px
    } else {
      setIsSticky(false); // Remove the sticky class when scrolled back to the top
    }
  };

  const handleCopy = (val) => {
    const inputval = val || document.getElementById("referralLink").value;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(inputval).then(() => {
        // setCopied(true);
        // setTimeout(() => setCopied(false), 2000); // Reset copied message after 2 seconds
        toast.success("copied successfuly!");
      });
    } else {
      alert("Clipboard API is not supported on your browser.");
    }
  };

  useEffect(() => {
    // Add the scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <header
        class={`app-header ${isSticky ? "position-fixed" : ""}`}
        style={{ width: "100%" }}
      >
        <nav class="navbar navbar-expand-lg navbar-dark">
          <ul
            class="navbar-nav"
            style={{
              width: "100%",
            }}
          >
            <li
              class=""
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <button
                className="nav-link sidebartoggler nav-icon-hover ms-n3"
                id="headerCollapse"
              >
                <i
                  class={`ti ti-menu-2 ${isMenuOpen ? "text-primary" : ""}`}
                  onClick={toggleMenu}
                ></i>
              </button>
              <div class="user-profile-img" onClick={toggleDropdown}>
                <img src={userlogo} class="rounded-circle userlogo" alt="" />
              </div>
              {/* </Link> */}
            </li>

            {/* <li class="nav-item d-none d-lg-block">
              <a
                class="nav-link nav-icon-hover"
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                <i class="ti ti-search"></i>
              </a>
            </li> */}
            {isDropdownOpen && (
              <div
                class="card text-white mb-2 box"
                className="dropdown-card"
                style={{
                  position: "absolute",
                  top: "90%", // Position below the user logo
                  right: "0",
                  boxShadow: "0 4px 8px rgba(110, 110, 110, 0.1)",
                  borderRadius: "18px",
                  background:"#062242",
                  padding:"25px",
                  zIndex: 1000, // Ensure it appears above other elements
                }}
              >
                <div class="card-body" style={{ height: "290px" }}>
                  <div class="text-center">
                    <img
                      src="assets copy/9187604.png"
                      alt="Profile Photo"
                      class="img-fluid rounded-circle mb-2"
                      style={{ width: "100px", height: "100px" }}
                    />
                  </div>
                  <h5 class="card-title text-white">
                    User-ID : {userinfo?.user_id}
                  </h5>

                  <h6 className=" mt-10">
                    <span>Wallet Address:</span>{" "}
                    <span class="text-white">
                      {walletAddress?.slice(0, 6)}...
                      {walletAddress?.slice(-6)}
                      <span
                        onClick={() => handleCopy(walletAddress)}
                        className=" mx-2"
                      >
                        <i
                          class="fa fa-copy"
                          style={{ fontSize: "15px", color: "#5D87FF" }}
                        ></i>
                      </span>
                    </span>
                  </h6>
                  <h6 className=" mt-10">
                    <span>Referred By:</span>{" "}
                    <span class="text-white">
                      {userinfo?.referrer?.slice(0, 6)}...
                      {userinfo?.referrer?.slice(-6)}
                      <span
                        onClick={() => handleCopy(userinfo?.referrer)}
                        className=" mx-2"
                      >
                        <i
                          class="fa fa-copy"
                          style={{ fontSize: "15px", color: "#5D87FF" }}
                        ></i>
                      </span>
                    </span>
                  </h6>
                  <h6 className=" mt-10">
                    <span>Join Date: </span>{" "}
                    {new Date(userinfo?.timestamp * 1000).toLocaleString()}
                  </h6>
                  <h6 className=" mt-10">
                    <span>
                      Referal Link:{" "}
                      {`${origin_url}/?referral=${
                        "..." + userinfo?.user.slice(-9)
                      }`}
                      <span
                        onClick={() =>
                          handleCopy(
                            `${origin_url}/?referral=${userinfo?.user}`
                          )
                        }
                        className=" mx-2"
                      >
                        <i
                          class="fa fa-copy"
                          style={{ fontSize: "15px", color: "#5D87FF" }}
                        ></i>
                      </span>
                    </span>{" "}
                    {}
                  </h6>
                </div>               
              </div>
            )}
          </ul>

          {/* <div class="d-block d-lg-none">
            <a href="#" target="_blank" style={{ width: 40 }}>
              {" "}
              <img src={whatsapp} alt="" style={{ width: 35 }} />
            </a>
          </div>
          <div class="d-block d-lg-none">
            <a href="#" target="_blank" style={{ width: 40 }}>
              <img src={insta} alt="" style={{ width: 35 }} />
            </a>
          </div>
          <div class="d-block d-lg-none">
            <a href="#" target="_blank" style={{ width: 40 }}>
              <img src={youtube} alt="" style={{ width: 35 }} />
            </a>
          </div>
          <div class="d-block d-lg-none">
            <a href="#" target="_blank" style={{ width: 40 }}>
              <img src={telegram} alt="" style={{ width: 35 }} />
            </a>
          </div> */}

          {/* <button
            class="navbar-toggler p-0 border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="true"
            aria-label="Toggle navigation"
          >
            <span class="p-2">
              <i class="ti ti-dots fs-7"></i>
            </span>
          </button> */}
          {/* Collapsible content */}
          {/* <div
            class="collapse navbar-collapse justify-content-end z-3"
            id="navbarNav"
            style={{ height: "70px" }}
          >
            <div class="d-flex align-items-center justify-content-between">
              <a
                href="#"
                class="nav-link d-flex d-lg-none align-items-center justify-content-center"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#mobilenavbar"
                aria-controls="offcanvasWithBothOptions"
              >
                <i class="ti ti-align-justified fs-7"></i>
              </a>
              <ul class="navbar-nav flex-row ms-auto align-items-center justify-content-center">
                <li class="nav-item ">
                  <div class="nav-link pe-0" id="drop1" aria-expanded="false">
                    <div class="d-flex align-items-center">
                      <div class="user-profile-img">
                        <img
                          src={userlogo}
                          class="rounded-circle userlogo"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div> */}
        </nav>
      </header>
    </>
  );
}

export default Navbar;
